(function () {
  'use strict';
  function availableFirst(items) {
    return items.filter(function (item) { return item.available; }).concat(
      items.filter(function (item) { return !item.available; })
    );
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { availableFirst: availableFirst };
  if (typeof document === 'undefined') return;
  function initFilters() {
    document.querySelectorAll('[data-jl-filter-toggle]').forEach(function (button) {
      if (button.dataset.jlFilterReady) return;
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.dataset.jlFilterReady = 'true';
      button.addEventListener('click', function () {
        var expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        panel.classList.toggle('is-open', expanded);
      });
    });
  }
  async function init() {
    initFilters();
    var config = document.querySelector('[data-jl-collection]');
    var grid = document.querySelector('.collection-main-body-inner');
    if (!config || !grid || grid.dataset.jlOrder) return;
    var pageSize = Number(config.dataset.pageSize);
    var currentPage = Number(config.dataset.currentPage);
    var total = Number(config.dataset.total);
    if (!total || !pageSize || !currentPage) return;
    grid.dataset.jlOrder = 'loading';
    grid.setAttribute('aria-busy', 'true');
    grid.classList.add('jl-catalog-sorting');
    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, 45000);
    function feedUrl(page) {
      var url = new URL(location.href);
      url.searchParams.set('view', 'jl-cards');
      url.searchParams.set('page', String(page));
      url.searchParams.delete('section_id');
      return url;
    }
    async function fetchPage(page) {
      var response = await fetch(feedUrl(page), { signal: controller.signal });
      if (!response.ok) throw new Error('Collection feed unavailable');
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var feed = doc.querySelector('[data-jl-feed]');
      if (!feed || Number(feed.dataset.total) !== total || Number(feed.dataset.page) !== page) throw new Error('Collection feed changed');
      return {
        pages: Number(feed.dataset.pages),
        items: Array.from(feed.querySelectorAll('[data-jl-feed-item]')).map(function (element) {
          var card = element.querySelector('[data-jl-product-id]');
          if (!card) throw new Error('Incomplete product card');
          return { id: card.dataset.jlProductId, available: card.dataset.jlAvailable === 'true', element: element };
        })
      };
    }
    try {
      var first = await fetchPage(1);
      var batches = [first];
      for (var page = 2; page <= first.pages; page += 2) {
        var pending = [fetchPage(page)];
        if (page + 1 <= first.pages) pending.push(fetchPage(page + 1));
        batches.push.apply(batches, await Promise.all(pending));
      }
      var items = batches.flatMap(function (batch) { return batch.items; });
      if (items.length !== total || new Set(items.map(function (item) { return item.id; })).size !== total) throw new Error('Collection count changed');
      var ordered = availableFirst(items);
      var start = (currentPage - 1) * pageSize;
      var visible = ordered.slice(start, start + pageSize);
      if (!visible.length) throw new Error('Collection page changed');
      var original = grid.querySelector('.grid__item');
      var classes = original ? original.className : document.querySelector('#grid_item_width_classes').value;
      var fragment = document.createDocumentFragment();
      visible.forEach(function (item) {
        item.element.className = classes.replace(/\b(?:wow|fadeInUp)\b/g, '').trim();
        item.element.removeAttribute('data-jl-feed-item');
        fragment.appendChild(item.element);
      });
      grid.replaceChildren(fragment);
      grid.dataset.jlOrder = 'available-first';
      grid.dataset.jlTotal = String(total);
      grid.dataset.jlAvailableCount = String(ordered.filter(function (item) { return item.available; }).length);
      if (window.Loox && typeof window.Loox.init === 'function') window.Loox.init();
      window.dispatchEvent(new Event('resize'));
    } catch (error) {
      grid.dataset.jlOrder = 'original';
    } finally {
      clearTimeout(timer);
      controller.abort();
      grid.removeAttribute('aria-busy');
      grid.classList.remove('jl-catalog-sorting');
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());
